import RichTextDataInputsService from './rich-text-data-inputs-service';

import { TEXT_BOX_FORMAT_TYPES } from './rich-text-box.const';

const dataInputs = RichTextDataInputsService.getOrderedDataInputs();
const reverseDataInputs = RichTextDataInputsService.getOrderedDataInputs().reverse();

/* Private */
function isRichText(format) {
	return [TEXT_BOX_FORMAT_TYPES.HTML, TEXT_BOX_FORMAT_TYPES.MARKDOWN].includes(format);
}

/* Public */

function toTiptapFormat(
	content,
	nodeId,
	options,
	dataChipConfig,
	showMultiSelectChips,
	paramKey,
	isTemplateMode,
	previousStepsData,
	richTextFieldFormat,
	replaceInsertDataStringDict
) {
	let newContent = RichTextDataInputsService.toTiptapPreprocessing(
		content,
		richTextFieldFormat,
		previousStepsData,
		replaceInsertDataStringDict
	);

	dataInputs.forEach((service) => {
		newContent = service.toTiptapFormat(newContent, nodeId, options, dataChipConfig, showMultiSelectChips, paramKey, isTemplateMode);
	});

	const result = RichTextDataInputsService.toTiptapPostprocessing(newContent, richTextFieldFormat);
	// console.log('-------> toTiptapFormat content:', content);
	// console.log('-------> toTiptapFormat result:', result);
	return result;
}

function fromTiptapFormat(content, readonly, multipleSelection, richTextFieldFormat, isTemplateMode) {
	const isRichTextEnabled = isRichText(richTextFieldFormat);
	let newContent = RichTextDataInputsService.fromTiptapPreprocessing(content, richTextFieldFormat);

	reverseDataInputs.forEach((service) => {
		newContent = service.fromTiptapFormat(newContent, readonly, multipleSelection, isRichTextEnabled, isTemplateMode);
	});

	let result = RichTextDataInputsService.fromTiptapPostprocessing(newContent, richTextFieldFormat);
	// // Special handling of &nbsp; unicode to a regular space
	// // We convert " " [spaces] with &nbsp;. See documentStringPreprocessing
	// Special handling of &nbsp; unicode to a regular space
	// We convert " " [spaces] with &nbsp;. See documentStringPreprocessing
	result = result.replaceAll(/\u00A0/g, ' '); // Replace &nbsp; with a space ( )

	// console.log('<------ fromTiptapFormat content:', content);
	// console.log('<------ fromTiptapFormat result:', result);
	return result;
}

const RichTextBoxService = {
	fromTiptapFormat,
	toTiptapFormat,
};

export default RichTextBoxService;
